import React from "react";
import {
  LoadingOutlined,
  ReloadOutlined,
  Loading3QuartersOutlined,
  HourglassOutlined,
  HourglassTwoTone,
} from "@ant-design/icons";
import { Spin } from "antd";
import {
  RotatingLines,
  FallingLines,
  MutatingDots,
} from "react-loader-spinner";
//import Logo from "../assets/img/icong_nobg.png";
const antIcon = (
  <HourglassTwoTone
    style={{
      fontSize: 50,
    }}
    spin
  />
);
function ThemedSuspense() {
  return (
    <div
      style={{ color: "#7835BF" }}
      className="flex w-full h-64 mt-40  text-lg justify-center font-extrabold text-gray-600 dark:text-gray-400 dark:bg-gray-900 "
    >
      {/* LOADING... */}
      {/* <Spin indicator={antIcon} size="large" /> */}

      <div className="grid grid-cols-1">
        {/* <img src={Logo} style={{ height: "80px", width: "80px" }} /> */}
        {/* <img src={Logo2} style={{ height: "20px", width: "150px" }} /> */}
        <div className="ml-6 mb-48">
          {/* <FallingLines
            color="#7835BF"
            width="100"
            visible={true}
            ariaLabel="falling-lines-loading"
          /> */}
          {/* <MutatingDots
            height="100"
            width="100"
            color="#7835BF"
            secondaryColor="#7835BF"
            radius="15"
            ariaLabel="mutating-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          /> */}
          <RotatingLines
            strokeColor="#7835BF"
            strokeWidth="4"
            animationDuration="0.75"
            width="55"
            visible={true}
          />
        </div>
      </div>
    </div>
  );
}

export default ThemedSuspense;
